import { createApp } from 'vue'
import App from './App.vue'
import pinia from './plugins/pinia';
import router, { route } from './router';
import { IonicVue, modalController } from '@ionic/vue';
import './plugins/vee-validate';
import i18n from "@/plugins/vue-i18n";

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './theme/global.css';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

import 'swiper/css';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/element/css/navigation';
import 'swiper/css/pagination';
import 'swiper/element/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/element/css/effect-fade';
import 'swiper/css/scrollbar';
import 'swiper/element/css/scrollbar';
import 'swiper/css/autoplay';
import { initSchemeListener, loadBodyTheme, setStatusBarStyle } from "@/functions/theme";
import { initApp } from "@/composables/useInit";
// TODO: Remove ts-ignore
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import VueVirtualScroller from 'vue-virtual-scroller';
import {
    CustomDisableSwipeBackDirective,
    CustomRouterGuardBackDirective,
    IonContentScrollbarDirective
} from "@/functions/directive";
import performUpdateCheck from "@/plugins/deploy";
import './functions/iosContextmenuEmulator';
import { usePersistentStore } from "@/stores/persistent";
import { getCustomConfig } from "@/plugins/config";
import { Capacitor } from "@capacitor/core";
import initSentry from "@/plugins/sentry";
import { URLOpenListenerEvent, App as CapacitorApp } from "@capacitor/app";

import SortableJS, { MultiDrag } from "sortablejs";

SortableJS.mount(new MultiDrag());

const app = createApp(App)
    .use(pinia)
    .use(VueVirtualScroller)
    .directive('disable-swipe-back', CustomDisableSwipeBackDirective)
    .directive('back-guard', CustomRouterGuardBackDirective)
    .directive('scrollbar', IonContentScrollbarDirective)

initSentry(app)

initApp().then(() => {
    app.use(IonicVue, getCustomConfig())
        .use(i18n)
        .use(router);

    router.isReady().then(async () => {
        app.mount('#app');
        if (Capacitor.isNativePlatform()) {
            await performUpdateCheck()
            setStatusBarStyle()
            initSchemeListener()
        }

        await CapacitorApp.addListener('appUrlOpen', function (event: URLOpenListenerEvent) {
            const url = new URL(event.url)

            if (url.pathname) {
                router.push({
                    path: url.pathname,
                    query: Object.fromEntries(url.searchParams)
                });
            }
        });

        loadBodyTheme()
    });

    document.addEventListener('ionBackButton', (ev) => {
        // TODO: Remove ts-ignore
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        ev.detail.register(98, async (processNextHandler) => {
            const top = await modalController.getTop()
            if (top) return
            if (route.value.meta?.disableBack) return
            if (usePersistentStore().offlineMode) return

            processNextHandler()
        })
    })
})

